import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
`;

export const Modal = styled.div`
  background-color: rgb(255,255,255);
  width: 50%;
  min-height: 20px;
  height: auto;
  z-index: 9999;
  border-radius: 4px;
  padding: 24px;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transform: translateY(0);
  opacity: 1;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;

  &.entering {
    transform: translateY(-20px);
    opacity: 0;
  }

  &.exiting {
    transform: translateY(20px);
    opacity: 0;
  }
`;
